module.exports = __webpack_public_path__ + "img/138.8f752212.jpg";